/* Copyright (c) 2025 MOCA Systems, Inc.  All rights reserved. */
import { AngularLandConnection, RefOrObservable } from '../base/interfaces';
import { ActiveLine, IActiveLine } from '../../../app-data/models/ActiveLine';
import { FancyFirebaseSplitDataObject } from '../generics/FancyFirebaseSplitDataObject';
import { DefaultSplitDataRenderType } from '@touchplan/common';
import { AngularFireAction, DatabaseSnapshot } from '@angular/fire/compat/database';

const settings = {
	//since this class is monitoring plan data and filtering out what it doesn't want
	//snapshot.exists() checks don't _really_ work. So we'll use check one of the
	//children key's existance as proxy
	nullProxyNode: 'activeLineDate',
};

/**
 * ActiveLineObject
 * This class extends FancyFirebaseObject to provide handling for ActiveLine data models.
 * It serves as a connection between Firebase real-time database and the application's data model,
 * handling the transformation of raw Firebase data into typed ActiveLine objects.
 * Specifically, this model handles the Firebase RTDB reads.
 */
export class ActiveLineObject extends FancyFirebaseSplitDataObject<
	IActiveLine,
	DefaultSplitDataRenderType,
	ActiveLine
> {
	protected splitDataFactory(child: DatabaseSnapshot<IActiveLine>): ActiveLine {
		return new ActiveLine(child.key);
	}
	/**
	 * ...creates the model
	 * @param angularLand - Connection object that interfaces with AngularFireDatabase
	 * @param path - Reference or Observable pointing to the Firebase database location
	 */
	constructor(angularLand: AngularLandConnection, path: RefOrObservable) {
		super(angularLand, path);
	}
	/**
	 *
	 * @param child - The Firebase snapshot containing updated data
	 * @returns A populated ActiveLine model or null if data doesn't exist
	 */
	public $$updated(child: AngularFireAction<DatabaseSnapshot<IActiveLine>>): null | ActiveLine {
		// custom exists check
		if (!child || !child.payload.exists() || !child.payload.child(settings.nullProxyNode).val()) {
			return null;
		}
		// then normal stuff
		return super.$$updated(child);
	}
}
